import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

const NO_QUESTIONS_TIP = "Add questions before turning this set on";

/** The row's on/off control; a set with no questions cannot be turned on. */
export const OnOffButton = ({ set, busy, onClick }) => {
  const button = (
    <Button
      size="sm"
      variant="outline-secondary"
      disabled={busy || (!set.active && set.question_count === 0)}
      onClick={onClick}
    >
      {set.active ? "Turn off" : "Turn on"}
    </Button>
  );
  if (set.active || set.question_count > 0) return button;

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`warm-up-set-no-questions-${set.id}`}>{NO_QUESTIONS_TIP}</Tooltip>}
    >
      <span className="d-inline-block" tabIndex={0}>
        {button}
      </span>
    </OverlayTrigger>
  );
};
